module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAp0lEQVRYR+3VSxGEQAwE0I4CVgISkIAUULI4AUfgqKnhtFvFfC6duQQDedVMJ4bOn3WejwBEApGALAGSHwCjmV2lqisBE4ATwGpmRw4hA6SBJBcAewkhBbQg5IAawgVQQrgBcogHQHIG8HW6jKkdqaJPO34BmyNg+AM4DX6tpdsbyO0EF0BpIckBtW0oBdSGp7cnA5Dse4y6n+PWast+QQAigUigNYEbNT9OIWL5yYAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiangyoujiantou.png
// module id = ajXJ
// module chunks = 1